<template>
  <div class="grid-x grid-margin-x grid-padding-y grid-padding-x margin-top-2 margin-bottom-1  align-center">
    <div class="cell medium-7 check-item-flame">
      <div class="information">
        <div>i</div>
      </div>
      <div class="grid-x margin-top-1 margin-left-3">
        <input
          id="item-check"
          :checked="accepted"
          type="checkbox"
          class="notice-check-item"
          data-test="notice-item-checkbox"
          @change="$emit('update:accepted', $event.target.checked)"
        >
        <label
          class="notice-check-style"
          for="item-check"
        />
        <label
          class="boss-color-red notice-check-label"
          for="item-check"
          data-test="notice-label"
        >
          {{ noticeLabel }}
        </label>
      </div>
      <div class="grid-x grid-margin-x align-center margin-top-1">
        <div class="cell medium-8">
          <slot name="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    noticeLabel: {
      type: String,
      required: true
    },
    accepted: {
      type: Boolean,
      required: true
    }
  }
}
</script>
